/**
 * Types van de verlofbeoordeling zoals `GET /api/workforce/leave-requests?action=beoordeling&id=`
 * ze teruggeeft. Kopie van de vormen in api/_lib/verlof-beoordeling.ts (de logica
 * leeft daar; de browser toont alleen).
 */
import type { VakantieSaldo } from './vakantie-saldo';

export type BeoordelingCode =
  | 'OVERLAP_APPROVED' | 'OVERLAP_PENDING' | 'SALDO_NEGATIEF' | 'COLLEGA_VRIJ'
  | 'INGEROOSTERD' | 'RIT_GEPLAND' | 'FEESTDAG_IN_RANGE' | 'PERIODE_GESLOTEN' | 'GEEN_DAGEN';

export type BeoordelingErnst = 'info' | 'let_op' | 'blokkeert';

export interface Waarschuwing {
  code: BeoordelingCode;
  ernst: BeoordelingErnst;
  tekst: string;
  details?: Record<string, unknown>;
}

export interface Beoordeling {
  aanvraag: { id: string | null; start_date: string; end_date: string; leave_type: string; dagen: number; uren: number };
  saldo_voor: VakantieSaldo | null;
  saldo_na: VakantieSaldo | null;
  feestdagen: { date: string; name: string }[];
  waarschuwingen: Waarschuwing[];
  geblokkeerd: boolean;
}

export const ERNST_CHIP: Record<BeoordelingErnst, string> = {
  info: 'bg-slate-100 text-slate-600 border-slate-200',
  let_op: 'bg-amber-50 text-amber-800 border-amber-200',
  blokkeert: 'bg-red-50 text-red-700 border-red-200',
};
